
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { Settings, Globe, Mail, Shield, Database } from "lucide-react";

const PlatformSettings = () => {
  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
        <Card className="bg-white/5 border-white/20">
          <CardHeader>
            <CardTitle className="text-white flex items-center">
              <Globe className="w-5 h-5 mr-2" />
              General Platform Settings
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label className="text-gray-300">Platform Name</Label>
              <Input 
                defaultValue="Metro City Groove"
                className="bg-white/10 border-white/20 text-white"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">Platform Description</Label>
              <Textarea 
                defaultValue="Africa's largest entertainment ecosystem connecting creators, venues, and music lovers."
                className="bg-white/10 border-white/20 text-white"
                rows={3}
              />
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">Contact Email</Label>
              <Input 
                type="email"
                defaultValue="support@metrocitygroove.com"
                className="bg-white/10 border-white/20 text-white"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">Support Phone</Label>
              <Input 
                defaultValue="+27 11 123 4567"
                className="bg-white/10 border-white/20 text-white"
              />
            </div>
          </CardContent>
        </Card>

        <Card className="bg-white/5 border-white/20">
          <CardHeader>
            <CardTitle className="text-white flex items-center">
              <Mail className="w-5 h-5 mr-2" />
              Email & Communication
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label className="text-gray-300">SMTP Server</Label>
              <Input 
                placeholder="smtp.gmail.com"
                className="bg-white/10 border-white/20 text-white placeholder-gray-400"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">SMTP Port</Label>
              <Input 
                type="number"
                defaultValue="587"
                className="bg-white/10 border-white/20 text-white"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">Email Username</Label>
              <Input 
                type="email"
                placeholder="noreply@metrocitygroove.com"
                className="bg-white/10 border-white/20 text-white placeholder-gray-400"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">Email Password</Label>
              <Input 
                type="password"
                placeholder="•••••••••"
                className="bg-white/10 border-white/20 text-white"
              />
            </div>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-white/5 border-white/20">
        <CardHeader>
          <CardTitle className="text-white flex items-center">
            <Shield className="w-5 h-5 mr-2" />
            Security & Privacy Settings
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <h3 className="text-white font-medium">User Registration</h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Email Verification Required</span>
                  <Switch defaultChecked />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Admin Approval Required</span>
                  <Switch />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Auto-approve Verified Users</span>
                  <Switch defaultChecked />
                </div>
              </div>
            </div>
            
            <div className="space-y-4">
              <h3 className="text-white font-medium">Content Policies</h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Auto-moderation Enabled</span>
                  <Switch defaultChecked />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Manual Review Required</span>
                  <Switch defaultChecked />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">User Reporting Enabled</span>
                  <Switch defaultChecked />
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white/5 border-white/20">
        <CardHeader>
          <CardTitle className="text-white flex items-center">
            <Database className="w-5 h-5 mr-2" />
            System Maintenance
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-3 gap-4">
            <Button className="bg-blue-500 text-white hover:bg-blue-600">
              <Database className="w-4 h-4 mr-2" />
              Backup Database
            </Button>
            <Button variant="outline" className="border-white text-white hover:bg-white hover:text-black">
              <Settings className="w-4 h-4 mr-2" />
              Clear Cache
            </Button>
            <Button variant="destructive" className="bg-red-500 text-white hover:bg-red-600">
              <Shield className="w-4 h-4 mr-2" />
              Maintenance Mode
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PlatformSettings;
